var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBlackBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 5.293C11.8945 5.48053 11.9998 5.73484 11.9998 6C11.9998 6.26516 11.8945 6.51947 11.707 6.707L7.41403 11H19C19.2652 11 19.5196 11.1054 19.7071 11.2929C19.8947 11.4804 20 11.7348 20 12C20 12.2652 19.8947 12.5196 19.7071 12.7071C19.5196 12.8946 19.2652 13 19 13H7.41403L11.707 17.293C11.8892 17.4816 11.99 17.7342 11.9877 17.9964C11.9854 18.2586 11.8803 18.5094 11.6948 18.6948C11.5094 18.8802 11.2586 18.9854 10.9964 18.9877C10.7342 18.99 10.4816 18.8892 10.293 18.707L4.29303 12.707C4.10556 12.5195 4.00024 12.2652 4.00024 12C4.00024 11.7348 4.10556 11.4805 4.29303 11.293L10.293 5.293C10.4806 5.10553 10.7349 5.00021 11 5.00021C11.2652 5.00021 11.5195 5.10553 11.707 5.293Z",
    fill: "#0D0D0D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlackBackArrow);
export default __webpack_public_path__ + "static/media/icon-black-back-arrow.c59824d51e7c311ae4ce88a7ebea0b84.svg";
export { ForwardRef as ReactComponent };